import { Grid, Typography, Button } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useDefectDojoData } from '../hooks/useDefectDojoData';
import { getProductIdFromEntity, isAnnotationInvalid } from '../utils/annotations';
import { SummaryCard } from './SummaryCard';
import { ProductInfoCard } from './ProductInfoCard';
import { FindingsTable } from './FindingsTable';
import { SeverityChart } from './SeverityChart';
import { StatusBarChart } from './StatusBarChart';
import { TrendLineChart } from './TrendLineChart';
import { Progress } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

export const DefectDojoPage = () => {
  const { entity } = useEntity();
  const configApi = useApi(configApiRef);
  const baseUrl = configApi.getString('defectDojo.baseUrl');
  const productId = getProductIdFromEntity(entity);
  const { product, findings, engagements, loading, error } =
    useDefectDojoData(productId);

  if (isAnnotationInvalid(entity)) {
    return (
      <Typography color="error">
        Anotação defectdojo.org/product-id inválida. Informe um ID numérico.
      </Typography>
    );
  }

  if (loading) return <Progress />;

  if (error) {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography color="error">
            Erro ao carregar dados do DefectDojo: {error.message}
          </Typography>
          <Button
            variant="outlined"
            onClick={() => window.location.reload()}
            style={{ marginTop: 8 }}
          >
            Tentar novamente
          </Button>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={3}>
      {/* Resumo — topo */}
      <Grid item xs={12} md={8}>
        <SummaryCard findings={findings} />
      </Grid>
      <Grid item xs={12} md={4}>
        {product && (
          <ProductInfoCard
            product={product}
            engagements={engagements}
            baseUrl={baseUrl}
          />
        )}
      </Grid>

      {/* Gráficos — meio */}
      <Grid item xs={12} md={4}>
        <SeverityChart findings={findings} />
      </Grid>
      <Grid item xs={12} md={4}>
        <StatusBarChart findings={findings} />
      </Grid>
      <Grid item xs={12} md={4}>
        <TrendLineChart findings={findings} />
      </Grid>

      {/* Tabela — inferior */}
      <Grid item xs={12}>
        <FindingsTable findings={findings} baseUrl={baseUrl} />
      </Grid>
    </Grid>
  );
};
